import { getDefaultExportFromCjs } from '../../_virtual/_commonjsHelpers.js';
import { a as axios$2 } from '../../_virtual/index.js';
import './lib/axios.js';
import { a as axios$1 } from '../../_virtual/axios.js';

(function (module) {
	module.exports = axios$1.exports;
} (axios$2));

var axios = /*@__PURE__*/getDefaultExportFromCjs(axios$2.exports);

export { axios as default };
//# sourceMappingURL=index.js.map
